// React Dependencies
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"

// External Dependencies
import { useLocation } from "react-router"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { AppBar, Paper, Tab, Tabs } from "@material-ui/core"

// Internal Dependencies
import FilterComponent from "./FilterComponent.jsx"
import { ListCompleted } from "./tab/ListCompleted.jsx"
import { ListActive } from "./tab/ListActive.jsx"
import { ListNewLand } from "./tab/ListNewLand.jsx"
import { ButtonDropdown, FilterCard } from "../../../../component/index.jsx"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { initialFilterTable } from "../../../../component/atoms/Tabel/index.jsx"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import {
  AREA_REGISTERED_ACTIVE_TAB_ENUM,
  AREA_REGISTERED_ENUM,
  LABEL_AREA_TAB_STATUS_ENUM,
  LABELING_CONST as ACTION_ENUM,
  LABELING_CONST,
  SUB_MENU_REGISTERED,
  isFrozen
} from "../../../../constants/StringConstant.js"
import { getKeyFromValue } from "../../../helpers/Utils.js"
import { useUrlParam } from "../../../hooks/useUrlParams.jsx"
import { clearDataDetail, getAllMitra } from "../../../../redux/actions/MitraAction.jsx"
import { setDataTabMultiple, SetFilterAction } from "../../../../redux/actions/FilterAction.js"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { Card } from "../../../../_metronic/_partials/controls/index.js"
import {
  blacklistAreas,
  downloadAreaXls,
  freezeAreas,
  getListRegisteredV2,
  getPlantingStatusEnum,
  unfreezeAreas
} from "../../../../redux/actions/AreaAction.jsx"
import { Button, Col, Row } from "react-bootstrap"
import { CloudDownload } from "@material-ui/icons"
import { FloatingSelectArea } from "../../../../component/atoms/FloatingSelectArea/index.jsx"
import { ModalFreezeArea } from "./ModalFreezeArea.jsx"
import { ModalBlacklistArea } from "./ModalBlacklistArea.jsx"
import { ModalUnfreezeArea } from "./ModalUnfreezeArea.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers.js"
import { AREA } from "../../../../constants/InitTypeConstants.js"
import swal from "sweetalert"
import { ROLE_ENUM } from "../../../../constants/RoleConstants.js"
import { isEqual } from "lodash"

const EMPTY_ITEMS_BY_TAB = { active: [], completed: [], newLand: [] }

export const AreaListTeregistrasiV2 = ({
  history,
  match: {
    params: { status }
  }
}) => {
  const dispatch = useDispatch()
  const searchRef = useRef()
  const filterRef = useRef()
  const subHeader = useSubheader()
  const location = useLocation()
  const urlParams = useUrlParam()
  const userLogin = useMemo(() => loadUserLogin(), [])
  const privileges = userLogin.privilege
  const role = userLogin?.role
  const { t } = useTranslation()
  const { General, Area } = useSelector((state) => state)
  const isReadOnly = false

  const [search, setSearch] = useState({
    keyword: ""
  })
  const [initialValue, setInitialValue] = useState({
    ...initialFilterTable,
    has_ba: "",
    min_area: "",
    max_area: "",
    mitra_id: "",
    province_id: "",
    regency_id: "",
    district_id: "",
    sub_district_id: "",
    label_type: ""
  })
  const [filterOn, setFilterOn] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [filterFormValues, setFilterFormValues] = useState(null)
  const [reset, setReset] = useState(false)
  const [mitra, setMitra] = useState("")
  const [hasBa, setHasBa] = useState("")
  const [min, setMin] = useState("")
  const [max, setMax] = useState("")
  const [labelType, setLabelType] = useState("")
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [tabActive, setTabActive] = useState(
    status === AREA_REGISTERED_ENUM.MT_COMPLETED
      ? 1
      : status === AREA_REGISTERED_ENUM.LAND_NEW
      ? 2
      : 0
  )
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const [isSelectable, setIsSelectable] = useState(false)
  const [isFreeze, setIsFreeze] = useState(false)
  const [freezeItemsByTab, setFreezeItemsByTab] = useState({ ...EMPTY_ITEMS_BY_TAB })
  const [showFreezeModal, setShowFreezeModal] = useState(false)
  const [isBlacklist, setIsBlacklist] = useState(false)
  const [blacklistItemsByTab, setBlacklistItemsByTab] = useState({ ...EMPTY_ITEMS_BY_TAB })
  const [showBlacklistModal, setShowBlacklistModal] = useState(false)
  const [isUnfreeze, setIsUnfreeze] = useState(false)
  const [unfreezeItemsByTab, setUnfreezeItemsByTab] = useState({ ...EMPTY_ITEMS_BY_TAB })
  const [showUnfreezeModal, setShowUnfreezeModal] = useState(false)

  const freezeItems = [
    ...freezeItemsByTab.active,
    ...freezeItemsByTab.completed,
    ...freezeItemsByTab.newLand
  ]
  const blacklistItems = [
    ...blacklistItemsByTab.active,
    ...blacklistItemsByTab.completed,
    ...blacklistItemsByTab.newLand
  ]
  const unfreezeItems = [
    ...unfreezeItemsByTab.active,
    ...unfreezeItemsByTab.completed,
    ...unfreezeItemsByTab.newLand
  ]

  // has_ba & label_type dibaca dari state (bukan formik) karena InputRadio
  // menulis value radio terakhir ke formik saat mount walau belum dipilih
  const btnFilterDisable = !(
    filterFormValues?.mitra_id ||
    filterFormValues?.province_id ||
    filterFormValues?.regency_id ||
    filterFormValues?.district_id ||
    filterFormValues?.sub_district_id ||
    filterFormValues?.min_area ||
    filterFormValues?.max_area ||
    mitra ||
    min ||
    max ||
    hasBa ||
    labelType
  )


  const fetchData = (param) => {
    dispatch(getListRegisteredV2(getKeyFromValue(status, AREA_REGISTERED_ENUM), param))
  }

  const searchFunc = (values) => {
    setSearch({ keyword: values.keyword })
    setIsActiveSearch(true)
    let param = {
      ...initialFilterTable,
      ...queryStringObj,
      keyword: values.keyword
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleReset = () => {
    let param = {
      ...initialFilterTable,
      ...initialValue,
      keyword: "",
      ...(queryStringObj?.tab
        ? { tab: queryStringObj?.tab }
        : status === AREA_REGISTERED_ENUM.MT_ACTIVE && {
            tab: getKeyFromValue(AREA_REGISTERED_ACTIVE_TAB_ENUM.NOT_PLANTED_YET)
          })
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ keyword: "" })
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const onChangeMitra = (e) => {
    setMitra(e)
  }

  const onChangeBa = (e) => {
    setHasBa(e)
  }

  const onChangeMin = (e) => {
    setMin(e)
  }

  const onChangeMax = (e) => {
    setMax(e)
  }

  const onChangeLabelType = (e) => {
    setLabelType(e)
  }

  const onSubmitForm = (e) => {
    setReset(false)
    const { values, submited } = e
    if (submited === true) {
      let param = {
        ...queryStringObj,
        has_ba: hasBa,
        min_area: values.min_area,
        max_area: values.max_area,
        mitra_id: values.mitra_id,
        province_id: values.province_id,
        regency_id: values.regency_id,
        district_id: values.district_id,
        sub_district_id: values.sub_district_id,
        keyword: search.keyword,
        label_type: labelType
      }
      if (param) {
        setInitialValue(param)
        const urlParam = getUrlParsingPageFilter(param)
        history.push({ pathname: location.pathname, search: urlParam })
        setShowFilter(false)
        setFilterOn(true)
      }
    }
  }

  const filterOnReset = () => {
    dispatch(SetFilterAction())
    setReset(true)
    setMitra("")
    setHasBa("")
    setMin("")
    setMax("")
    setLabelType("")
    setShowFilter(false)
    setFilterOn(false)
    let param = {
      ...initialFilterTable,
      has_ba: "",
      min_area: "",
      max_area: "",
      mitra_id: "",
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      label_type: "",
      keyword: search.keyword,
      ...(queryStringObj?.tab && { tab: queryStringObj?.tab })
    }
    setInitialValue(param)
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleOpenCloseFilter = (value) => {
    setShowFilter(value)
  }
  
  const initialValueRef = useRef(initialValue)

  useEffect(() => {
    initialValueRef.current = initialValue
  }, [initialValue])
  useEffect(() => {
    searchRef.current = search
  }, [search])

  // ---
  
  const changePage = useCallback(
    (param) => {
      // Baca dari ref — selalu dapat nilai terbaru
      const currentInitialValue = initialValueRef.current
      const currentSearch = searchRef.current

      // location dibaca langsung saat fungsi dipanggil (fine)
      const currentParams = new URLSearchParams(location.search)
      const currentTab = currentParams.get("tab")

      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...currentInitialValue,
          ...param,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          keyword: currentSearch.keyword,
          ...(currentTab && { tab: currentTab })
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...currentInitialValue,
          ...param,
          keyword: currentSearch.keyword,
          ...(currentTab && { tab: currentTab })
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [history, location] // ← stable, tidak trigger re-render loop
  )

  const changeTabs = (data) => {
    dispatch(setDataTabMultiple(data))
    setTabActive(data)
    let urlParam = ""
    let param = {
      ...initialValue,
      keyword: search.keyword
    }
    urlParam = getUrlParsingPageFilter(param)
    if (data === 1) {
      history.push(
        RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.MT_COMPLETED) + urlParam ??
          ""
      )
    } else if (data === 2) {
      history.push(
        RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.LAND_NEW) + urlParam ?? ""
      )
    } else {
      history.push(
        RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(AREA_REGISTERED_ENUM.MT_ACTIVE) +
          getUrlParsingPageFilter({
            ...param,
            tab: getKeyFromValue(
              AREA_REGISTERED_ACTIVE_TAB_ENUM.NOT_PLANTED_YET,
              AREA_REGISTERED_ACTIVE_TAB_ENUM
            )
          }) ?? ""
      )
    }
  }

  const handleChangeSubTab = (tab) => {
    let param = getUrlParsingPageFilter({
      ...queryStringObj,
      tab,
      sort: ""
    })

    history.push({ pathname: location.pathname, search: param })
  }

  const getTabsContents = () => {
    const labelList = []
    const ComponentsList = []

    const actionType = isFreeze
      ? LABELING_CONST.FREEZE
      : isBlacklist
      ? LABELING_CONST.BLACKLIST
      : isUnfreeze
      ? LABELING_CONST.UNFREEZE
      : null

    const activeMT = (
      <>
        <ListActive
          data={Area}
          changePage={changePage}
          history={history}
          general={General}
          initialFilterTable={initialFilterTable}
          isActiveSearch={isActiveSearch}
          filterOn={filterOn}
          handleChangeSubTab={handleChangeSubTab}
          initialActive={queryStringObj?.tab}
          isMultiSelect={isSelectable}
          actionType={actionType}
          initialSelectedItems={
            isFreeze
              ? freezeItemsByTab.active
              : isBlacklist
              ? blacklistItemsByTab.active
              : isUnfreeze
              ? unfreezeItemsByTab.active
              : []
          }
          onSelectionChange={(selectedRows) => {
            if (isSelectable) {
              if (isFreeze) setFreezeItemsByTab((prev) => ({ ...prev, active: selectedRows }))
              else if (isBlacklist)
                setBlacklistItemsByTab((prev) => ({ ...prev, active: selectedRows }))
              else if (isUnfreeze)
                setUnfreezeItemsByTab((prev) => ({ ...prev, active: selectedRows }))
            }
          }}
        />
      </>
    )
    const completed = (
      <ListCompleted
        data={Area}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isActiveSearch={isActiveSearch}
        filterOn={filterOn}
        isMultiSelect={isSelectable}
        actionType={actionType}
        initialSelectedItems={
          isFreeze
            ? freezeItemsByTab.completed
            : isBlacklist
            ? blacklistItemsByTab.completed
            : isUnfreeze
            ? unfreezeItemsByTab.completed
            : []
        }
        onSelectionChange={(selectedRows) => {
          if (isSelectable) {
            if (isFreeze) setFreezeItemsByTab((prev) => ({ ...prev, completed: selectedRows }))
            else if (isBlacklist)
              setBlacklistItemsByTab((prev) => ({ ...prev, completed: selectedRows }))
            else if (isUnfreeze)
              setUnfreezeItemsByTab((prev) => ({ ...prev, completed: selectedRows }))
          }
        }}
      />
    )
    const newLand = (
      <ListNewLand
        data={Area}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isActiveSearch={isActiveSearch}
        filterOn={filterOn}
        isMultiSelect={isSelectable}
        actionType={actionType}
        initialSelectedItems={
          isFreeze
            ? freezeItemsByTab.newLand
            : isBlacklist
            ? blacklistItemsByTab.newLand
            : isUnfreeze
            ? unfreezeItemsByTab.newLand
            : []
        }
        onSelectionChange={(selectedRows) => {
          if (isSelectable) {
            if (isFreeze) setFreezeItemsByTab((prev) => ({ ...prev, newLand: selectedRows }))
            else if (isBlacklist)
              setBlacklistItemsByTab((prev) => ({ ...prev, newLand: selectedRows }))
            else if (isUnfreeze)
              setUnfreezeItemsByTab((prev) => ({ ...prev, newLand: selectedRows }))
          }
        }}
      />
    )

    if (privileges.indexOf(PRIVILEGE_ENUM.LIST_AREA_REGISTERED_TAB_ALL) >= 0) {
      ComponentsList.push(activeMT)
      labelList.push({
        label: t("table_header_active_mt"),
        labelTooltip: "",
        icon: ""
      })
    }
    if (privileges.indexOf(PRIVILEGE_ENUM.LIST_AREA_REGISTERED_TAB_AREA) >= 0) {
      ComponentsList.push(completed)
      labelList.push({
        label: t("table_header_completed"),
        labelTooltip: "",
        icon: ""
      })
    }
    if (privileges.indexOf(PRIVILEGE_ENUM.LIST_AREA_REGISTERED_TAB_AREA_KUR) >= 0) {
      ComponentsList.push(newLand)
      labelList.push({
        label: t("table_header_new_land"),
        labelTooltip: "",
        icon: ""
      })
    }

    return {
      labels: labelList,
      contents: ComponentsList
    }
  }

  const onClickDownloadExport = () => {
    if (status) {
      const currentParams = new URLSearchParams(location.search)
      const currentTab = currentParams.get("tab")
      const dataParams = { ...initialValue, tab: currentTab }
      const allowedKeys = [
        "has_ba",
        "min_area",
        "max_area",
        "mitra_id",
        "province_id",
        "regency_id",
        "district_id",
        "sub_district_id",
        "tab"
      ]
      const cleanParams = Object.fromEntries(
        Object.entries(dataParams).filter(
          ([k, v]) => allowedKeys.includes(k) && v !== "" && v !== null && v !== undefined
        )
      )

      const getLabelAreaTabStatus = (status) => {
        const key = status?.replace(/-/g, "_")
        return LABEL_AREA_TAB_STATUS_ENUM[key] ?? ""
      }

      const getLabelSubMenuRegistered = (status) => {
        return SUB_MENU_REGISTERED[status] ?? ""
      }

      const subMenu = getLabelAreaTabStatus(status)
      const tabName = getLabelSubMenuRegistered(currentTab)?.replace(/\s/g, "_")
      const currentDate = new Date()
        .toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric" })
        .replace(/\//g, "") // "23042026"
      const currentTime = new Date()
        .toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })
        .replace(/[:.]/g, "") // "1608" ✅ fix di sini

      const _fileName = tabName
        ? `Lahan_Teregistrasi_${subMenu}_${tabName}_${currentDate}_${currentTime}`.replace(
            /\s/g,
            "_"
          )
        : `Lahan_Teregistrasi_${subMenu}_${currentDate}_${currentTime}`.replace(/\s/g, "_")

      dispatch(
        downloadAreaXls({
          status,
          params: cleanParams,
          fileName: _fileName
        })
      )
    }
  }

  useEffect(() => {
    setTabActive(
      status === AREA_REGISTERED_ENUM.MT_COMPLETED
        ? 1
        : status === AREA_REGISTERED_ENUM.LAND_NEW
        ? 2
        : 0
    )
  }, [status])

  const dropdownMenu = useMemo(
    () => [
      {
        title: t("label_freeze"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.PAUSE),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isFreeze) {
            setFreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsSelectable(false)
            setIsFreeze(false)
          } else {
            setIsBlacklist(false)
            setBlacklistItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsUnfreeze(false)
            setUnfreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsFreeze(true)
            setIsSelectable(true)
          }
        }
      },
      {
        title: t("label_blacklist"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.BLACKLIST),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isBlacklist) {
            setBlacklistItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsSelectable(false)
            setIsBlacklist(false)
          } else {
            setIsFreeze(false)
            setFreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsUnfreeze(false)
            setUnfreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsBlacklist(true)
            setIsSelectable(true)
          }
        }
      },
      {
        title: t("label_unfreeze"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.UNFREEZE),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isUnfreeze) {
            setUnfreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsSelectable(false)
            setIsUnfreeze(false)
          } else {
            setIsFreeze(false)
            setFreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsBlacklist(false)
            setBlacklistItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
            setIsUnfreeze(true)
            setIsSelectable(true)
          }
        }
      }
    ],
    [isFreeze, isBlacklist, isUnfreeze, privileges]
  )

  useEffect(() => {
    subHeader.setTitle(t("sub_header_registered_area"))

    const isFinanceWithPrivilege =
      privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) > -1 && role === ROLE_ENUM.FINANCE

    const buttons = (
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          className={General.loading ? "" : "bg-transparent text-primary"}
          onClick={() => onClickDownloadExport()}
          disabled={General.loading}>
          <Row>
            <Col md={"auto"}>
              <CloudDownload />
            </Col>
            <Col md={"auto"}>{t("label_download_area")}</Col>
          </Row>
        </Button>

        {isFinanceWithPrivilege && (
          <ButtonDropdown variant={"outline-primary"} iconOnly dropdownList={dropdownMenu} />
        )}
      </div>
    )

    subHeader.setButton(buttons)

    // dispatch(getAllMitra())
    // dispatch(getPlantingStatusEnum())
    //
    // return () => {
    //   dispatch(clearDataDetail())
    // }
  }, [isSelectable, isFreeze, isBlacklist, isUnfreeze, General.loading, privileges, role])

  useEffect(() => {
    // Hanya jalankan logic saat actionInitType berubah
    if (!General.actionInitType) return

    // contoh: tutup modal, refresh data, dsb
    if (
      General.actionInitType === ACTION_ENUM.FREEZE ||
      General.actionInitType === ACTION_ENUM.BLACKLIST ||
      General.actionInitType === ACTION_ENUM.UNFREEZE
    ) {
      dispatch(getAllMitra())
      // setShowModal(false), dsb.
    }
  }, [General.actionInitType])

  useEffect(() => {
    dispatch(getAllMitra())
    dispatch(getPlantingStatusEnum())
    return () => dispatch(clearDataDetail())
  }, []) // hanya saat mount & unmount

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
    if (
      queryStringObj?.has_ba ||
      queryStringObj?.min_area ||
      queryStringObj?.max_area ||
      queryStringObj?.mitra_id ||
      queryStringObj?.province_id ||
      queryStringObj?.regency_id ||
      queryStringObj?.district_id ||
      queryStringObj?.sub_district_id ||
      queryStringObj?.label_type
    ) {
      setFilterOn(true)
      const data = {
        ...initialFilterTable,
        keyword: queryStringObj?.keyword,
        has_ba: queryStringObj?.has_ba,
        min_area: queryStringObj?.min_area,
        max_area: queryStringObj?.max_area,
        mitra_id: queryStringObj?.mitra_id,
        province_id: queryStringObj?.province_id,
        regency_id: queryStringObj?.regency_id,
        district_id: queryStringObj?.district_id,
        sub_district_id: queryStringObj?.sub_district_id,
        label_type: queryStringObj?.label_type
      }
      if (data) {
        setInitialValue(data)
        setMitra(queryStringObj?.mitra_id)
        setHasBa(queryStringObj?.has_ba)
        setMin(queryStringObj?.min_area)
        setMax(queryStringObj?.max_area)
        setLabelType(queryStringObj?.label_type)
      }
    }
  }, [queryStringObj, dispatch])

  useEffect(() => {
    const search = location?.search
      ? location.search
      : status === AREA_REGISTERED_ENUM.MT_ACTIVE
      ? getUrlParsingPageFilter({
          tab: getKeyFromValue(
            AREA_REGISTERED_ACTIVE_TAB_ENUM.NOT_PLANTED_YET,
            AREA_REGISTERED_ACTIVE_TAB_ENUM
          )
        })
      : ""
    fetchData(search)
  }, [location.search])

  useEffect(() => {
    if (status === AREA_REGISTERED_ENUM.MT_ACTIVE) {
      const params = new URLSearchParams(location.search || "")
      if (!params.get("tab")) {
        const tabValue = getKeyFromValue(
          AREA_REGISTERED_ACTIVE_TAB_ENUM.NOT_PLANTED_YET,
          AREA_REGISTERED_ACTIVE_TAB_ENUM
        )
        const merged = {
          ...(queryStringObj ?? {}),
          tab: tabValue
        }
        const urlParam = getUrlParsingPageFilter(merged)
        history.replace({ pathname: location.pathname, search: urlParam })
      }
    }
  }, [status, location.search, queryStringObj, history])

  useEffect(() => {
    const newParams = urlParams.getUrlParamsObj
    setQueryStringObj((prev) => (isEqual(prev, newParams) ? prev : newParams))
  }, [urlParams.getUrlParamsObj])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General.actionInitType === AREA.FREEZE_AREA) {
      swal(t("messages_response_success_freeze_area"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_FREEZE_AREA
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === AREA.BLACKLIST_AREA) {
      swal(t("messages_response_success_blacklist_area"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_BLACKLIST_AREA
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === AREA.UNFREEZE_AREA) {
      swal(t("messages_response_success_unfreeze_area"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_UNFREEZE_AREA
      }).then(() => {
        history.replace(0)
      })
    }
  }, [General.isFinishUpdateOrDelete, General.actionInitType])

  return (
    <>
      <FilterCard
        // search
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_insert_area_name_or_farmer")}
        onSubmitForm={searchFunc}
        initialValues={search}
        name={"keyword"}
        innerRef={searchRef}
        trigerReset={handleReset}
        // filter
        filterInnerRef={filterRef}
        filterHandleSubmit={onSubmitForm}
        filterFormInitialValues={initialValue}
        filterComponent={
          <FilterComponent
            isReadOnly={isReadOnly}
            onChangeMitra={onChangeMitra}
            onChangeBa={onChangeBa}
            onChangeMin={onChangeMin}
            onChangeMax={onChangeMax}
            onChangeLabelType={onChangeLabelType}
            mitra={mitra}
            hasBa={hasBa}
            min={min}
            max={max}
            labelType={labelType}
            reset={reset}
            onValuesChange={setFilterFormValues}
            key={JSON.stringify(queryStringObj)}
          />
        }
        filterOnReset={filterOnReset}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}
      />
      <Card className={"px-12 py-8"}>
        <RowModule>
          <Paper square className={`tabIcon`}>
            <AppBar position="static" color="transparent">
              <Tabs
                value={tabActive}
                indicatorColor={"primary"}
                textColor="primary"
                onChange={(e, newValue) => changeTabs(newValue)}>
                {getTabsContents().labels.map((item, i) => {
                  return <Tab key={i} label={`${item?.label}`} />
                })}
              </Tabs>
            </AppBar>
          </Paper>
        </RowModule>
        {getTabsContents().contents[tabActive]}
      </Card>
      {isSelectable && isFreeze ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_area_name")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.AREA_CHECK)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsFreeze(false)
                  setIsSelectable(false)
                  setFreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={freezeItems.length === 0}
                onClick={() => setShowFreezeModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_freeze")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {freezeItems.length} {t("label_area_name")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      {isSelectable && isBlacklist ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_area_name")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.AREA_CHECK)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsBlacklist(false)
                  setIsSelectable(false)
                  setBlacklistItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={blacklistItems.length === 0}
                onClick={() => setShowBlacklistModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_blacklist")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {blacklistItems.length} {t("label_area_name")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      <ModalFreezeArea
        show={showFreezeModal}
        onClose={() => {
          setShowFreezeModal(false)
        }}
        onSubmit={(values) => {
          dispatch(
            freezeAreas({
              action: LABELING_CONST.FREEZE,
              document: {
                name: values.file_name,
                size: values.file_size,
                url: values.file_contract_url
              },
              reason: values.reason,
              area_ids: freezeItems.map((item) => item.land_id)
            })
          )
          setIsFreeze(false)
          setIsSelectable(false)
          setFreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
        }}
      />
      <ModalBlacklistArea
        show={showBlacklistModal}
        onClose={() => {
          setShowBlacklistModal(false)
        }}
        onSubmit={(values) => {
          dispatch(
            blacklistAreas({
              action: LABELING_CONST.BLACKLIST,
              document: {
                name: values.file_name,
                size: values.file_size,
                url: values.file_contract_url
              },
              reason: values.reason,
              area_ids: blacklistItems.map((item) => item.land_id)
            })
          )
          setIsBlacklist(false)
          setIsSelectable(false)
          setBlacklistItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
        }}
      />
      {isSelectable && isUnfreeze ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_area_name")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.AREA_CHECK)}
          customButtonSection={() => {
            const frozenItems = unfreezeItems.filter(
              (item) => isFrozen(item.area_status)
            )
            const nonFreezeItems = unfreezeItems.filter(
              (item) => !isFrozen(item.area_status)
            )
            return (
              <>
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setIsUnfreeze(false)
                    setIsSelectable(false)
                    setUnfreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
                  }}
                  className={"d-flex align-items-center ml-4"}>
                  {t("button_batal")}
                </Button>
                <Button
                  variant="primary"
                  disabled={nonFreezeItems.length > 0 || frozenItems.length === 0}
                  onClick={() => setShowUnfreezeModal(true)}
                  className={"d-flex align-items-center ml-4"}>
                  {t("label_unfreeze")}
                </Button>
              </>
            )
          }}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {unfreezeItems.length} {t("label_area_name")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      <ModalUnfreezeArea
        show={showUnfreezeModal}
        onClose={() => {
          setShowUnfreezeModal(false)
        }}
        onSubmit={(values) => {
          const frozenItems = unfreezeItems.filter(
            (item) => isFrozen(item.area_status)
          )
          dispatch(
            unfreezeAreas({
              action: LABELING_CONST.UNFREEZE,
              reason: values.reason,
              area_ids: frozenItems.map((item) => item.land_id)
            })
          )
          setIsUnfreeze(false)
          setIsSelectable(false)
          setUnfreezeItemsByTab({ ...EMPTY_ITEMS_BY_TAB })
        }}
      />
    </>
  )
}
